import React, { useCallback } from 'react';
import { FormControl, TextField, InputAdornment } from '@mui/material';

function normalize(value: number | undefined, scale: number | undefined) {
    if (scale === undefined) return value;
    if (value === undefined) return undefined;
    return Math.floor(value / scale);
}

function denormalize(value: number, scale: number | undefined) {
    if (scale === undefined) return value;
    return value * scale;
}

export type LabeledNumberFieldProps = {
    label: string;
    suffix?: string;
    disabled: boolean;
    value?: number;
    scale?: number;
    onChange?: (value: number | undefined) => void;
}

export function LabeledNumberField(props: LabeledNumberFieldProps) {
    const { label, suffix, disabled, value: rawValue, scale, onChange } = props;

    const value = normalize(rawValue, scale);

    const onTextChange = useCallback((e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
        if (!onChange) return undefined;

        const v = parseFloat(e.target.value);
        if (isNaN(v)) return onChange(undefined);

        return onChange(denormalize(v, scale));
    }, [onChange, scale]);

    return (
        <FormControl sx={{
            margin: theme => theme.spacing(1),
        }}>
            <TextField
                label={label}
                disabled={disabled}
                type={value === undefined ? 'string' : 'number'}
                InputLabelProps={{
                    shrink: value !== undefined,
                }}
                InputProps={{
                    endAdornment: value !== undefined && suffix ? <InputAdornment position="end">{suffix}</InputAdornment> : undefined
                }}
                value={value ?? ''}
                onChange={onTextChange}
            />
        </FormControl>
    );
}
